export const HOME = '/'
export const QUOTE = '/quote'
export const RATES_FORM = '/rates-form'
export const POLICY_FORM = '/policy-form'
export const CERTS = '/certificate'
export const HIRE = '/contratar-poliza'

